export default __webpack_public_path__ + "static/screeny-110-gc-cabrio-2-6ae3ff3e6b753e65aafc0d8322110912.jpg";